<template>
  <v-container class="text-left" fluid style="padding: 0">
    <v-row>
      <v-col cols="12" sm="4">
        <v-card flat style="background-color: transparent">
          <v-card-actions>
            <v-text-field
              style="margin-top: 2px !important"
              class="search-box"
              placeholder="Search Users By Name Or Email"
              prepend-icon="fa-search"
              v-model="search"
              type="text"
              clearable
              clear-icon="fa-times"
              @click:clear="resetSearch"
              @keyup="applySearch"
            ></v-text-field>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="12">
        <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '' }"></v-skeleton-loader>
            <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
        <v-data-table
          :headers="computedHeaders"
          :options.sync="options"
          :server-items-length="serverItemsLength"
          v-show="!loading"
          :items="users"
        >
          <template v-slot:item.confirmed="{ item }">
            <v-icon v-if="item.confirmed" color="primary">fa-check</v-icon>
            <v-icon v-else color="error">fa-times</v-icon>
          </template>
          <template v-slot:item.improve="{ item }">
            <v-switch
              :disabled="item.state == 4"
              @change="
                item.is_improve_content
                  ? addImproveContent(item.id)
                  : removeContent(item.company_id, item.id, 0)
              "
              v-model="item.is_improve_content"
              :value="item.is_improve_content"
            ></v-switch>
          </template>
          <template v-slot:item.edify="{ item }">
            <v-switch
              :disabled="item.state == 4"
              @change="
                item.is_edify_content
                  ? addEdifyContent(item.id)
                  : removeContent(item.company_id, item.id, 1)
              "
              v-model="item.is_edify_content"
              :value="item.is_edify_content"
            ></v-switch>
          </template>
          <!-- Dynamic slots for membership packages -->
          <template v-for="pckg in membershipPackages" v-slot:[`item.${pckg.id}`]="{ item }">
            <v-switch :key="pckg.id" :disabled="item.state == 4" @change="
              item.membership_package_id.includes(pckg.id)
                ? addMembershipContent(item.id, item.company_id, pckg.id, pckg.name)
                : removeContent(item.company_id, item.id, 2, pckg.id, pckg.name)
              " v-model="item.membership_package_id" :value="pckg.id"></v-switch>
          </template>
          <template v-slot:item.id="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="item.state == 4"
                  :id="item.id"
                  v-on="on"
                  outlined
                  small
                  color="secondary"
                  @click.prevent="showEditPanel(item.id)"
                >
                  <v-icon small>fa-pencil-alt</v-icon>
                </v-btn>
              </template>
              <span>Edit User</span>
            </v-tooltip>
            <!-- State Suspend button -->
            <v-tooltip bottom v-if="item.state != 4">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  color="error"
                  class="ml-1"
                  outlined
                  small
                  @click.prevent="updateState(item.company.data.id, 'suspend')"
                >
                  <v-icon small>fa fa-ban</v-icon>
                </v-btn>
              </template>
              <span>Suspend Company</span>
            </v-tooltip>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  color="error"
                  class="ml-1"
                  outlined
                  small
                  @click.prevent="updateState(item.company.data.id, 'active')"
                >
                  <v-icon small>fa fa-undo</v-icon>
                </v-btn>
              </template>
              <span>Active Company</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import superAdminAPI from '@/api/superadmin.js';
import partnerAPI from '@/api/partner.js';
import EditUser from '@/components/superadmin/users/PartnerCustomerEdit';
import improveAPI from '@/api/superadmin.js';
import companyAPI from '@/api/company.js';

export default {
  name: 'SuperAdminCompanyUsers',
  components: {},
  data() {
    return {
      headers: [
        { text: 'Company', value: 'company.data.company_name' },
        {
          text: 'Banding',
          value: 'company.data.banding_description.name',
          sortable: false,
        },
        {
          text: 'Total Users',
          value: 'company.data.total_members',
          sortable: false,
        },
        {
          text: 'Total Courses',
          value: 'company.data.total_courses',
          sortable: false,
        },
        {
          text: 'State',
          value: 'company.data.state_description',
          sortable: false,
        },
        { text: 'First Name', value: 'first_name' },
        //{ text: "Surname", value: "last_name" },
        { text: 'Email', value: 'email' },
        { text: 'Last Login', value: 'last_login', sortable: false },
        //{ text: "Courses", value: "total_courses", sortable: false },
        //{ text: "Groups", value: "total_groups", sortable: false },
        //{ text: "Playlists", value: "total_channels", sortable: false },
        { text: '', value: 'id', align: 'end' },
      ],
      partnerId: this.$route.params.id,
      users: [],
      companies: [],
      partner: [],
      search: '',
      timer: null,
      fetchTimer: null,
      searchParams: '',
      pagination: {},
      options: {},
      loading: false,
      confirmDelete: 'Are you sure you wish to delete this user?',
      confirmRemoveContent: 'Are you sure you want to remove all courses?',
      successMessage: 'content successfully activated.',
      removeContentMessage: 'content now deactivated.',
      confirmUpdateCompanyState: 'Are you sure you wish to update state to ',
      successUpdateStateMessage: 'State has been updated Successfully',
      membershipPackages: [],
    };
  },
  computed: {
    computedHeaders() {
      let headers = [...this.headers];
      if (this.$globalConfig.APP_NAME == 'senso') {
        headers.splice(2, 0,
          { text: 'Compliance', value: 'improve', sortable: false },
          { text: 'Safeguarding', value: 'edify', sortable: false }
        );
        this.membershipPackages.forEach((membershipPackage, index) => {
          headers.splice(4 + index, 0, { text: membershipPackage.name, value: membershipPackage.id, sortable: false});
        });
      }
      return headers;
    },
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options, this.serverItemsLength);
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  mounted() {
    this.setEventBus();
    if (this.$globalConfig.APP_NAME == 'senso') {
      this.getMembershipPackages();
    }
  },
  watch: {
    options: {
      handler() {
        this.queueFetch();
      },
      deep: true,
    },
  },
  beforeDestroy() {
    // A pending debounce must not fire on a torn-down component.
    clearTimeout(this.timer);
  },
  methods: {
    queueFetch() {
      // Collapses the burst of watcher fires a page or search change produces
      // into exactly one request.
      clearTimeout(this.fetchTimer);
      this.fetchTimer = setTimeout(this.getUsers, 50);
    },
    getUsers() {
      this.loading = true;
      //userAPI.getClients(this.params, this.searchParams, this.companyId).then(resp => {
      //partnerAPI.getPartnerDetailByUserId(this.partnerId, this.params+ '&include=partnerusers').then(resp => {
      partnerAPI
        .getPartnersUser(
          this.params + '&include=company',
          this.searchParams,
          this.partnerId
        )
        .then((resp) => {
          this.users = resp.data.data;
          //this.companies = resp.data.data.company.data;
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    resetSearch() {
      clearTimeout(this.timer);
      this.search = '';
      this.runSearch();
    },
    runSearch() {
      // Fragment only. getUsers already passes params plus '&include=company';
      // prefixing them here produced a second '?' and a duplicate include.
      if (this.search) {
        const q = encodeURIComponent(this.search);
        this.searchParams =
          '&search=first_name:' + q + ';last_name:' + q + ';email:' + q;
      } else {
        this.searchParams = '';
      }
      // One fetch, whatever happens. Resetting the page makes the deep watcher
      // fire, and Vuetify can emit more than one options update per change, so
      // both paths go through the same queue rather than racing each other.
      this.options.page = 1;
      this.queueFetch();
    },
    setEventBus() {
      EventBus.$on('USERS_UPDATED', (payload) => {
        // this.params = payload;
        this.getUsers();
      });
    },
    applySearch() {
      // Debounced so a search fires once the admin stops typing, not per keystroke.
      clearTimeout(this.timer);
      this.timer = setTimeout(this.runSearch, 1000);
    },
    showEditPanel(id) {
      this.$showPanel({
        component: EditUser,
        props: {
          id: id,
          params: this.params,
        },
        openOn: 'right',
      });
    },
    addImproveContent(companyId) {
      this.loading = true;
      improveAPI
        .createEdifyImproveContent(this.$store.getters.user.id, companyId)
        .then(() => {
          this.$snotify.success('Compliance ' + this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch((err) => {
          this.getUsers();
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    addEdifyContent(companyId) {
      this.loading = true;
      improveAPI
        .createEdifyContent(this.$store.getters.user.id, companyId)
        .then(() => {
          this.$snotify.success('Safeguarding ' + this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch((err) => {
          this.getUsers();
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    removeContent(id, userId, contentType,packageId = '', packageName = '') {
      this.$snotify.confirm(this.confirmRemoveContent, {
        backdrop:0.3,                         
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button', action: (toast) => this.removeToast(toast) },
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) =>
              this.processRemoveContent(toast, id, userId, contentType, packageId, packageName),
          }          
        ],
      });
    },
    removeToast(toast) {
      this.$snotify.remove(toast.id);
      this.getUsers();
    },
    processRemoveContent(toast, id, userId, contentType, packageId, packageName) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      superAdminAPI
        .removeEdifyImproveContent(id, userId, contentType, packageId)
        .then((resp) => {
          this.getUsers();
          this.loading = false;
          var successMessage = '';
          if(packageName == ''){
           successMessage = contentType
            ? 'Safeguarding ' + this.removeContentMessage
            : 'Compliance ' + this.removeContentMessage;
          }else{
            successMessage = packageName + ' Package ' + this.removeContentMessage;
          }
          this.$snotify.success(successMessage);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    updateState(id, state = '') {
      var confirmUpdateCompanyState =
        this.confirmUpdateCompanyState + state + '?';
      this.$snotify.confirm(confirmUpdateCompanyState, {
        backdrop:0.3,                         
        buttons: [
          { text: 'Cancel', className: 'toast-cancel-button'},
          {
            text: 'Continue',
            className: 'toast-continue-button',
            action: (toast) => this.processUpdateCompanyState(toast, id, state),
          }          
        ],
      });
    },
    processUpdateCompanyState(toast, id, state) {
      this.$snotify.remove(toast.id);
      this.loading = true;
      companyAPI.updateCompanyState(id, '', state).then(() => {
        this.$snotify.success(this.successUpdateStateMessage);
        this.getUsers();
        this.loading = false;
        setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
      });
    },
    getMembershipPackages(){
      improveAPI.getMembershipPackages().then(response => {
            this.membershipPackages = response.data.data;
        });
    },
    addMembershipContent(id, companyId, packageId, packageName){
      this.loading = true;
      improveAPI
        .createMembershipContent(this.$store.getters.user.id, id, companyId, packageId)
        .then(() => {
          this.$snotify.success(packageName + ' Package ' + this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch((err) => {
          this.getCompanies();
          this.valid = false;
          this.messages = this.$gf.errorResponse(err);
          this.$snotify.error(this.errorMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    }
  },
};
</script>
